function ChangePageSizeRdc() {
    const changePageSizeRdc = (state, payload) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, rowsPerPage: payload, page: 0 });
    };
    return changePageSizeRdc;
}
export default ChangePageSizeRdc;
//# sourceMappingURL=ChangePageSizeRdc.js.map